import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=3ecb886f&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./auth.less?vue&type=style&index=0&id=3ecb886f&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb886f",
  null
  
)

export default component.exports